import React from 'react';
import ContentLayout from 'src/components/ContentLayout';
import Text from 'src/components/Text';
import ApproveByPlugin from './ApproveByPlugin';
import ApproveByThirdPartySoftware from './ApproveByThirdPartySoftware';

const AddOrganization: React.FC = () => {
  return (
    <ContentLayout size="medium">
      <Text type="p">
        Чтобы самостоятельно добавить новую организацию в список, требуется подтвердить
        принадлежность к этой организации с помощью электронной подписи. Есть два варианта как это
        сделать:
      </Text>
      <Text type="h3">1. Если ЭП есть непосредственно у вас.</Text>
      <ApproveByPlugin />
      <Text type="h3">2. Если ЭП есть у другого сотрудника организации.</Text>
      <ApproveByThirdPartySoftware />
      <Text type="p" italic>
        Пользователь, который подтвердил принадлежность к организации с помощью электронной
        подписи, может отправить приглашение другим сотрудникам организации на почту
      </Text>
    </ContentLayout>
  );
};

export default AddOrganization;
